import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
class GuardCacheService {
  private tokenResult: { valid: boolean; expiry: number } | null = null;
  private readonly CACHE_TTL_MS = 45_000;

  check(valid: boolean): boolean {
    const now = Date.now();
    if (this.tokenResult && now < this.tokenResult.expiry) {
      return this.tokenResult.valid;
    }
    this.tokenResult = { valid, expiry: now + this.CACHE_TTL_MS };
    return valid;
  }
}

export const authGuard: CanActivateFn = async (_route, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const guardCache = inject(GuardCacheService);

  if (!auth.isLoggedIn) {
    auth.saveRedirect(state.url);
    return router.createUrlTree(['/login']);
  }

  const valid = await auth.validateToken();

  if (guardCache.check(valid)) return true;

  auth.saveRedirect(state.url);
  return router.createUrlTree(['/login']);
};
